import React from 'react';

// Icona rotonda fluttuante (bottom-right) con anello di progresso animato mentre la
// verifica e' in corso; a esito pronto passa allo stato "pronto" (verde, spunta) o
// "errore" (rosso, punto esclamativo). Tap -> riapre l'overlay.
export default function VerificaFab({ ready, errored, onClick }) {
  const stato = errored ? 'errore' : ready ? 'pronto' : '';
  return (
    <button type="button" className={`m-fab-verifica ${stato}`.trim()} onClick={onClick}
      aria-label={errored ? 'Verifica in errore' : ready ? 'Esito verifica pronto' : 'Verifica in corso'}>
      {!ready && !errored && (
        <svg className="ring" width="56" height="56" viewBox="0 0 56 56">
          <circle className="trk" cx="28" cy="28" r="24" fill="none" strokeWidth="4" />
          <circle className="arc" cx="28" cy="28" r="24" fill="none" strokeWidth="4" strokeLinecap="round" />
        </svg>
      )}
      <span className="ic">
        {errored ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 8v5M12 16.5v.5" /><circle cx="12" cy="12" r="9" /></svg>
        ) : ready ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L7.6 9.8a16 16 0 0 0 6 6l1.4-1.4a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6A2 2 0 0 1 22 16.9z" /></svg>
        )}
      </span>
    </button>
  );
}
